/**
 * Common JS functions
 */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import $ from 'jquery';
import videojs from 'video.js/dist/alt/video.novtt';
import cAppeared from '../components/c-appeared';
import navBurger from '../blocks/nav-burger';
import navProp from '../blocks/navp';
import outline from '../components/c-outline';
import header from '../blocks/header';
import preloader from '../components/c-preloader';
import bookingPreloader from '../components/booking-preloader';
import cookieConsentDelay from '../components/c-cookie-consent-delay';
import cSkipMain from '../components/c-skip-main';
import videoControls, { initVideoControls } from '../components/c-video-controls';
import { breakpoints } from '../config/breakpoints';

window.videojs = videojs;

cookieConsentDelay();
cAppeared();
header();
navBurger();
navProp($);
outline();
bookingPreloader();
preloader();
cSkipMain();
videoControls();

// initImagesLazyLoad();

// function initImagesLazyLoad() {
//     observer = lozad(); // lazy loads elements with default selector as '.lozad'
//     observer.observe();
// }

/**
 * Pendry Form Remove Auto-Label
 * @param targetId
 */
function pendryFormRemoveAutoLabel(targetId) {
  $(`#${targetId}`).closest('.wpcf7-form-control-wrap').find(`#label_${targetId}`).remove();
}

/**
 * Pendry Form Remove All Auto-Labels
 * @param formId
 */
function pendryFormRemoveAllAutoLabels(formId) {
  $(`#${formId}`).find('.form__label-auto').remove();
}

/**
 * Pendry Form Remove auto aria-label
 * @param targetId
 */
function pendryFormRemoveAutoAriaLabel(targetId) {
  $(`#${targetId}`).removeAttr('aria-label');
}

/**
 * Pendry Form Auto-Label
 * @param targetId
 * @param targetValue
 */
function pendryFormAutoLabel(targetId, targetValue) {
  let placeholder;

  if ($(`#${targetId}`).attr('placeholder')) {
    placeholder = $(`#${targetId}`).attr('placeholder');
  } else if ($(`#${targetId}`).closest('div').data('placeholder')) {
    placeholder = $(`#${targetId}`).closest('div').data('placeholder');
  } else {
    placeholder = $(`#${targetId}`).attr('name');
  }

  const label = `<span for="${targetId}" id="label_${targetId}" class="form__label-auto">${placeholder}</span>`;

  if (targetValue !== '' && $(`#label_${targetId}`).length === 0) {
    $(`#${targetId}`).closest('.wpcf7-form-control-wrap').prepend(label);
    pendryFormRemoveAutoAriaLabel(targetId);
  }
  if (targetValue === '' || targetValue.toLowerCase() === $(`#${targetId}`).attr('name').toLowerCase()) {
    pendryFormRemoveAutoLabel(targetId);
  }
}

window.pendryFormAutoLabel = pendryFormAutoLabel;

/**
 * CF7 form submit listener
 */
document.addEventListener('wpcf7mailsent', (event) => {
  const id = event.target.id || event.target.closest('.wpcf7').getAttribute('id');
  pendryFormRemoveAllAutoLabels(id);
}, false);

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    const wpcf7Forms = document.querySelectorAll('form.wpcf7-form');

    wpcf7Forms.forEach((form) => {
      form.reset();
      const wrap = form.closest('.wpcf7');
      if (wrap) {
        pendryFormRemoveAllAutoLabels(wrap.getAttribute('id'));
      }
    });
  }
});

// jQuery functions
(function () {
  function smoothScroll(hash) {
    const duration = 0;
    let headerHeight = 0;

    if (window.screen.width >= breakpoints.lg) {
      headerHeight = $('.header-container .navp-container').height();
    } else {
      headerHeight = $('.header-container .header').height();
    }

    const blockScrollMargin = parseInt($(hash).css('scroll-margin-top'), 10);
    let scrollTopValue = 0;

    if (blockScrollMargin) {
      scrollTopValue = $(hash).offset().top - blockScrollMargin;
    } else {
      scrollTopValue = $(hash).offset().top - headerHeight;
    }

    if ($(hash).hasClass('item-offer')) {
      const elOfferDetails = $(`${hash} + .item-offer-details`);
      const offerDetailsBottom = elOfferDetails.offset().top + elOfferDetails.outerHeight();
      const viewPortBottom = scrollTopValue + document.documentElement.clientHeight;
      const heightDiff = viewPortBottom - offerDetailsBottom;

      if (heightDiff < 0) {
        scrollTopValue = offerDetailsBottom - document.documentElement.clientHeight;
      }
    }

    $('html,body').animate({ scrollTop: scrollTopValue }, duration);

    setTimeout(() => {
      $(document).trigger('scrollToHash', [hash]);
    }, duration);
  }

  function getLocation(href) {
    const l = document.createElement('a');
    l.href = href;
    return l;
  }

  function catchHash() {
    const { hash } = window.location;
    const bookingPath = '/(#/)';
    // Exit if booking page
    if (window.location.href.match(bookingPath)) {
      return false;
    }
    if (!$(hash).length) {
      return false;
    }
    if (hash) {
      smoothScroll(hash);
    }

    return false;
  }

  $(document).on('click', '.navigation__sub-navigation-link[href*=\\#]', function (event) {
    const requestedLinkPath = getLocation($(this).attr('href')).pathname;
    const pathName = window.location.pathname;
    const { hash } = this;

    if (requestedLinkPath.replace(/^\/|\/$/g, '') === pathName.replace(/^\/|\/$/g, '')) {
      event.preventDefault();
      window.history.pushState('', document.title, window.location.pathname + hash);
      smoothScroll(hash);
    }
  });
  // @todo what is it?
  // $(document).scroll(() => {
  //   const { hash } = window.location;
  //   /* eslint-disable-next-line */
  //   const hashu = hash.replace(/^\#|\/$/g, '');
  //   const element = document.getElementById(hashu);
  //   if (element) {
  //     const topPos = element.getBoundingClientRect();
  //   }
  // });

  $(window).bind('hashchange load', () => {
    catchHash();
  });

  $(window).ready(() => {
    catchHash();
  });

  // Add form auto-label
  $(document).on('input change', '.form__input', (event) => {
    if (!event.target.closest('.deactivate-auto-label')) {
      pendryFormAutoLabel(event.target.id, event.target.value);
    }
  });

  /**
     * All drop downs
     * @type {*|HTMLElement}
     */
  const $dropDown = $('.form__input--select');

  $dropDown.change(function () {
    if ($(this).val() === '') {
      $(this).addClass('form__input--empty');
    } else {
      $(this).removeClass('form__input--empty');
    }
  });
  $dropDown.change();
}());

function initVideoJsPlayers() {
  const initVideoJsPlayer = (video) => {
    if (video.dataset.vjsInitialized) {
      return window.videojs(video);
    }
    // eslint-disable-next-line no-param-reassign
    video.dataset.vjsInitialized = 'true';

    const isClickToPlay = video.classList.contains('enabledPoster');

    let srcUrl = null;
    let srcType = null;
    const source = video.querySelector('source[data-src]');
    if (source) {
      srcUrl = source.dataset.src;
      srcType = source.getAttribute('type');
      source.removeAttribute('data-src');
      source.setAttribute('src', srcUrl);
    }

    const mobilePoster = video.getAttribute('data-mobile-poster');
    if (mobilePoster && window.innerWidth < 768) {
      video.setAttribute('poster', mobilePoster);
      // eslint-disable-next-line no-param-reassign
      video.style.backgroundImage = `url('${mobilePoster}')`;
    }

    const videoJsPlayer = videojs(video, {
      muted: true,
      loop: true,
      // Click-to-play boxes are laid out by the stylesheet (width:100% + aspect-ratio).
      // Without fluid mode video.js stamps the source's intrinsic size onto the player
      // on init, which overrides that box — a 1920x1080 source renders 1080px tall.
      fluid: isClickToPlay,
      html5: {
        vhs: {
          overrideNative: true,
          limitRenditionByPlayerDimensions: true,
          useDevicePixelRatio: true,
          bandwidth: 5000000,
        },
      },
    });

    if (srcUrl) {
      videoJsPlayer.src({ type: srcType, src: srcUrl });
    }
    videoJsPlayer.ready(() => {
      // "enabledPoster" players are click-to-play: they show a poster behind their own
      // centre play button and must stay paused until the visitor starts them.
      if (!isClickToPlay) {
        videoJsPlayer.play();
      }

      if (video.classList.contains('hasPlayPause') && video.tagName === 'VIDEO-JS') {
        const videoElem = videoJsPlayer.el().querySelector('video');

        if (videoElem) {
          initVideoControls([videoElem], 100 + Math.floor(Math.random() * 200));
        }
      }
    });

    return videoJsPlayer;
  };

  const lazyLoadVideoJs = (video) => {
    let timeoutId;
    const initOnInteraction = () => {
      clearTimeout(timeoutId);
      initVideoJsPlayer(video);
      window.removeEventListener('scroll', initOnInteraction);
      window.removeEventListener('touchstart', initOnInteraction);
      window.removeEventListener('mousemove', initOnInteraction);
    };

    const scheduleTimeout = () => {
      timeoutId = setTimeout(initOnInteraction, 2000);
    };

    if (document.readyState === 'complete') {
      scheduleTimeout();
    } else {
      window.addEventListener('load', scheduleTimeout, { once: true });
    }

    window.addEventListener('scroll', initOnInteraction, { once: true, passive: true });
    window.addEventListener('touchstart', initOnInteraction, { once: true, passive: true });
    window.addEventListener('mousemove', initOnInteraction, { once: true, passive: true });
  };

  window.initLazyVideoJsPlayer = initVideoJsPlayer;

  // Native <video>: poster defaults to mobile crop. Swap to desktop on wide viewports.
  // This prevents the browser downloading both sizes — mobile is the HTML default,
  // desktop is set by JS only when needed (and already preloaded via <link rel="preload" media>).
  document.querySelectorAll('video[data-desktop-poster]').forEach((video) => {
    if (window.innerWidth >= 768) {
      video.setAttribute('poster', video.getAttribute('data-desktop-poster'));
    }
  });

  document.querySelectorAll('video-js.autoDetect').forEach((video) => {
    lazyLoadVideoJs(video);
  });

  document.querySelectorAll('video-js.enabledPoster').forEach((video) => {
    const initPosterVideo = () => {
      if (!video.dataset.vjsInitializedPoster) {
        // eslint-disable-next-line no-param-reassign
        video.dataset.vjsInitializedPoster = 'true';
        initVideoJsPlayer(video);
      }
    };

    let timeoutId;
    const initOnInteraction = () => {
      clearTimeout(timeoutId);
      initPosterVideo();
      window.removeEventListener('scroll', initOnInteraction);
      window.removeEventListener('touchstart', initOnInteraction);
    };

    const scheduleTimeout = () => {
      timeoutId = setTimeout(initOnInteraction, 2000);
    };

    if (document.readyState === 'complete') {
      scheduleTimeout();
    } else {
      window.addEventListener('load', scheduleTimeout, { once: true });
    }

    window.addEventListener('scroll', initOnInteraction, { once: true, passive: true });
    window.addEventListener('touchstart', initOnInteraction, { once: true, passive: true });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVideoJsPlayers);
} else {
  initVideoJsPlayers();
}
